import gql from 'graphql-tag';
import { storeBasicFields } from './GetStore';

const key = `ListStores`;
const query = gql`
query ${key} {
  listStores (limit: 999){
    items{
      ${storeBasicFields}
    }
  }
}
`;

export const LIST_STORES = { key, query };
